// report-card favorites. this used to be its own localStorage list
// ('rds_favorites'), which silently reset on every sign-in because
// login.vue's created() hook clears localStorage. it is now a thin adapter
// over the shared, server-synced nav favorites store, so a starred report
// follows the user across devices AND shows up in the sidebar's Favorites
// section alongside starred pages.
//
// the report surfaces deal in bare route names; a bare name is already the
// canonical favorite key for a destination with no pinned query, so the two
// vocabularies line up with no translation.
import { favState, isFavorite as navIsFavorite, toggleFavorite as navToggleFavorite } from '@/nav/nav_favorites'

export { ensureFavoritesLoaded } from '@/nav/nav_favorites'

// report_shell / report_dashboard_shell hold this in data() and read
// `.routes` in computeds. a getter keeps that call site working while the
// real state lives in favState -- reading favState.keys inside the getter is
// what registers the reactive dependency during render.
export const favoritesState = {
  get routes() {
    return favState.keys
  },
}

export function isFavorite(route) {
  return navIsFavorite({ name: route })
}

export function toggleFavorite(route) {
  navToggleFavorite({ name: route })
}
